import { render, staticRenderFns } from "./public.vue?vue&type=template&id=473cef64&"
import script from "./public.ts?vue&type=script&lang=ts&"
export * from "./public.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports